<div class="mt-5">
	<h2>Writ Search</h2>
	<p class="my-5 text-grey">Select parties to complete writ search</p>
	<app-writ-results [hideButton]="hideButton"></app-writ-results>
</div>
